/**
 * @fileoverview Global functions for native and custom functionalities
 * that were added to the theme.
 */

/**
 * ----------------------------------------------------------------------------
 * Currency and money helpers
 * ----------------------------------------------------------------------------
 */

/**
 * Converts product prices from cents to a properly formatted currency format
 * with its currency symbol.
 * @param {number} cents - Price represented in cents.
 * @returns {string} - Formatted amount with currency symbol.
 */
function formatPriceWithCurrencySymbol(cents) {
  var shopCurrencyIsoName = $(
    '.CurrencySelector__Select option:selected'
  ).val();
  var tempWithCurrencySymbol = $('#shop-currency-symbol').text();
  var formattedAmountWithCurrency = currencyFormat(cents, shopCurrencyIsoName);
  var priceWithSymbol = tempWithCurrencySymbol.replace(
    /[\d]/g,
    formattedAmountWithCurrency
  );
  return priceWithSymbol;
}

/**
 * Formats amount in cents in International Currency Conversion.
 * Reference: https://help.shopify.com/en/manual/payments/currency-formatting
 * @param {number} amount - Price in cents (29 <-- 2900).
 * @param {string} currencyIsoName - Alphabetical code for country names. US
 *   dollar is represented in USD.
 * @returns {string} - Formatted amount in accordance to currency formats.
 */
function currencyFormat(amount, currencyIsoName) {
  const currencyFormats = {
    USD: '{{amount}}',
    EUR: '{{amount}}',
    GBP: '{{amount}}',
    CAD: '{{amount}}',
    ALL: '{{amount}}',
    DZD: '{{amount}}',
    AOA: '{{amount}}',
    ARS: '{{amount_with_comma_separator}}',
    AMD: '{{amount}}',
    AWG: '{{amount}}',
    AUD: '{{amount}}',
    BBD: '{{amount}}',
    AZN: '{{amount}}',
    BDT: '{{amount}}',
    BSD: '{{amount}}',
    BHD: '{{amount}}',
    BYR: '{{amount}}',
    BZD: '{{amount}}',
    BTN: '{{amount}}',
    BAM: '{{amount_with_comma_separator}}',
    BRL: '{{amount_with_comma_separator}}',
    BOB: '{{amount_with_comma_separator}}',
    BWP: '{{amount}}',
    BND: '{{amount}}',
    BGN: '{{amount}}',
    MMK: '{{amount}}',
    KHR: '{{amount}}',
    KYD: '{{amount}}',
    XAF: '{{amount}}',
    CLP: '{{amount_no_decimals}}',
    CNY: '{{amount}}',
    COP: '{{amount_with_comma_separator}}',
    CRC: '{{amount_with_comma_separator}}',
    HRK: '{{amount_with_comma_separator}}',
    CZK: '{{amount_with_comma_separator}}',
    DKK: '{{amount_with_comma_separator}}',
    DOP: '{{amount}}',
    XCD: '{{amount}}',
    EGP: '{{amount}}',
    ETB: '{{amount}}',
    XPF: '{{amount_no_decimals_with_comma_separator}}',
    FJD: '{{amount}}',
    GMD: '{{amount}}',
    GHS: '{{amount}}',
    GTQ: '{{amount}}',
    GYD: '{{amount}}',
    GEL: '{{amount}}',
    HNL: '{{amount}}',
    HKD: '{{amount}}',
    HUF: '{{amount_no_decimals_with_comma_separator}}',
    ISK: '{{amount_no_decimals}}',
    INR: '{{amount}}',
    IDR: '{{amount_with_comma_separator}}',
    ILS: '{{amount}}',
    JMD: '{{amount}}',
    JPY: '{{amount_no_decimals}}',
    JEP: '{{amount}}',
    JOD: '{{amount}}',
    KZT: '{{amount}}',
    KES: '{{amount}}',
    KWD: '{{amount}}',
    KGS: '{{amount}}',
    LVL: '{{amount}}',
    LBP: '{{amount}}',
    LTL: '{{amount}}',
    MGA: '{{amount}}',
    MKD: '{{amount}}',
    MOP: '{{amount}}',
    MVR: '{{amount}}',
    MXN: '{{amount}}',
    MYR: '{{amount}}',
    MUR: '{{amount}}',
    MDL: '{{amount}}',
    MAD: '{{amount}}',
    MNT: '{{amount_no_decimals}}',
    MZN: '{{amount}}',
    NAD: '{{amount}}',
    NPR: '{{amount}}',
    ANG: '{{amount}}',
    NZD: '{{amount}}',
    NIO: '{{amount}}',
    NGN: '{{amount}}',
    NOK: '{{amount_with_comma_separator}}',
    OMR: '{{amount_with_comma_separator}}',
    PKR: '{{amount}}',
    PGK: '{{amount}}',
    PYG: '{{amount_no_decimals_with_comma_separator}}',
    PEN: '{{amount}}',
    PHP: '{{amount}}',
    PLN: '{{amount_with_comma_separator}}',
    QAR: '{{amount_with_comma_separator}}',
    RON: '{{amount_with_comma_separator}}',
    RUB: '{{amount_with_comma_separator}}',
    RWF: '{{amount_no_decimals}}',
    WST: '{{amount}}',
    SAR: '{{amount}}',
    STD: '{{amount}}',
    RSD: '{{amount}}',
    SCR: '{{amount}}',
    SGD: '{{amount}}',
    SYP: '{{amount}}',
    ZAR: '{{amount}}',
    KRW: '{{amount_no_decimals}}',
    LKR: '{{amount}}',
    SEK: '{{amount_no_decimals}}',
    CHF: '{{amount}}',
    TWD: '{{amount}}',
    THB: '{{amount}}',
    TZS: '{{amount}}',
    TTD: '{{amount}}',
    TND: '{{amount}}',
    TRY: '{{amount}}',
    UGX: '{{amount_no_decimals}}',
    UAH: '{{amount}}',
    AED: '{{amount}}',
    UYU: '{{amount_with_comma_separator}}',
    VUV: '{{amount}}',
    VEF: '{{amount_with_comma_separator}}',
    VND: '{{amount_with_comma_separator}}',
    XBT: '{{amount_no_decimals}}',
    XOF: '{{amount}}',
    ZMW: '{{amount_no_decimals_with_comma_separator}}',
  };

  var cents = amount;
  var format = currencyFormats[currencyIsoName];

  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || '${{amount}}';

  function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ',');
    decimal = defaultTo(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      ),
      centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  var value = '';

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, ',', '.');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
  }

  if (formatString.indexOf('with_comma_separator') !== -1) {
    return formatString.replace(placeholderRegex, value).replace(',00', '');
  } else {
    return formatString.replace(placeholderRegex, value).replace('.00', '');
  }
}

/**
 * Subtracts a percentage from an amount.
 * @param {number} amount - Original amount to be subtracted from.
 * @param {number} percentage - Percentage to subract from the original amount.
 * @returns {number} - The amount after subtracting the percentage.
 */
function subtractPercentage(amount, percentage) {
  return amount - (amount * percentage) / 100;
}

/**
 * ----------------------------------------------------------------------------
 * Encoder and decoders
 * ----------------------------------------------------------------------------
 */

/**
 * Decodes string data that is stored in client side.
 */
function decodeBase64(str) {
  return decodeURIComponent(escape(window.atob(str)));
}

String.prototype.hashCode = function () {
  var hash = 0,
    i,
    chr;
  if (this.length === 0) return hash;
  for (i = 0; i < this.length; i++) {
    chr = this.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer.
  }
  return hash;
};

/**
 * Converts an array of string or numbers to an id.
 * @param {Array} arr - Array of strings or numbers to be hashed.
 * @returns {string} - Hashed id from the given array.
 */
function bundleIdBuilder(arr) {
  var bundleId = arr.sort().join('');
  // Compress the unique id to a smaller number.
  bundleId = bundleId.hashCode().toString();

  // Replace negative numbers with starting 0's.
  bundleId = bundleId.replace(/[-]/g, '0');
  return bundleId;
}

/**
 * ----------------------------------------------------------------------------
 * Debuggers
 * ----------------------------------------------------------------------------
 */

/**
 * Shows all the items currently in cart.
 */
function cartDataDebugger() {
  var cartContents = fetch(window.theme.localeRootUrl + '/cart.js')
    .then((response) => response.json())
    .then((data) => {
      return data;
    });

  cartContents.then((cartData) => {
    var cartItems = cartData.items;
    console.log('cart items: ', cartItems);
  });
}

/**
 * ----------------------------------------------------------------------------
 * Sale settings
 * ----------------------------------------------------------------------------
 */

/**
 * @typedef {Object} SaleSettings
 * @property {Object} sale_settings - Sale settings object.
 * @property {Object} sale_settings.sitewide - Sitewide sale settings object.
 * @property {boolean} sale_settings.sitewide.active - Whether sitewide sale is
 *   active or not.
 * @property {Object} sale_settings.sale_by_tag - Sale by tag settings object.
 * @property {boolean} sale_settings.sale_by_tag.active- Whether sale by tag
 *   is active or not.
 * @property {string} sale_settings.sale_by_tag.tag - Tag to be used for sale
 *   by tag.
 * @property {number} sale_settings.key - Discount to be used for sitewide sale
 *   or sale by tag.
 */

/**
 * Decodes the site settings from the base64 encoded site settings global
 * variable and returns site settings in a JSON/Object format.
 * @returns {SaleSettings} siteSettings - Site settings object.
 */
function getSiteSettings() {
  return JSON.parse(decodeBase64(SITE_SETTINGS));
}
